@let currentLanguage = this.currentLanguage();
@let config = this.config();

@let withCallWaiterMain = this.withCallWaiterMain();
@let withCallWaiterAnotherRound = this.withCallWaiterAnotherRound();
@let withCallWaiterRequestBill = this.withCallWaiterRequestBill();

@let callWaiterMain = this.callWaiterMain();
@let callWaiterAnotherRound = this.callWaiterAnotherRound();
@let callWaiterRequestBill = this.callWaiterRequestBill();

@if (withCallWaiterMain && config.main.enabled) {
  @let active = callWaiterMain;
  @let disabled = callWaiterAnotherRound || callWaiterRequestBill;
  @let labelFallback = config.main.label.normal | textTranslate:'fallback';

  <button
    class="button"
    [class.active]="active"
    [disabled]="disabled"
    [coreUserActivityClickTracking]="callWaiterService.getTrackingName('main', active)"
    (click)="onClickCallWaiterMain($event)"
  >
    @if (config.main.icon) {
      @let icon = (
        (active && config.main.icon.active)
          ? config.main.icon.active
          : config.main.icon.normal
      ) | imageTranslate: currentLanguage;

      <app-image
        class="icon"
        [image]="icon"
        [alt]="labelFallback"
      />
    }

    <div class="content">
      @if (active && config.main.label.active) {
        <app-text @fadeIn class="label">{{ config.main.label.active | textTranslate: currentLanguage }}</app-text>
      } @else {
        <app-text @fadeIn class="label">{{ config.main.label.normal | textTranslate: currentLanguage }}</app-text>
      }

      @if (config.main.description) {
        @if (active && config.main.description.active) {
          <app-text @fadeIn class="description">{{ config.main.description.active | textTranslate: currentLanguage }}
          </app-text>
        } @else {
          <app-text @fadeIn class="description">{{ config.main.description.normal | textTranslate: currentLanguage }}
          </app-text>
        }
      }
    </div>
  </button>
}

@if (withCallWaiterAnotherRound && config.anotherRound.enabled) {
  @let active = callWaiterAnotherRound;
  @let disabled = callWaiterMain || callWaiterRequestBill;
  @let labelFallback = config.anotherRound.label.normal | textTranslate:'fallback';

  <button
    class="button"
    [class.active]="active"
    [disabled]="disabled"
    [coreUserActivityClickTracking]="callWaiterService.getTrackingName('tertiary', active)"
    (click)="onClickCallWaiterAnotherRound($event)"
  >
    @if (config.anotherRound.icon) {
      @let icon = (
        active && config.anotherRound.icon.active
          ? config.anotherRound.icon.active
          : config.anotherRound.icon.normal
      ) | imageTranslate: currentLanguage;

      <app-image
        class="icon"
        [image]="icon"
        [alt]="labelFallback"
      />
    }

    <div class="content">
      @if (active && config.anotherRound.label.active) {
        <app-text @fadeIn class="label">{{ config.anotherRound.label.active | textTranslate: currentLanguage }}
        </app-text>
      } @else {
        <app-text @fadeIn class="label">{{ config.anotherRound.label.normal | textTranslate: currentLanguage }}
        </app-text>
      }

      @if (config.anotherRound.description) {
        @if (active && config.anotherRound.description.active) {
          <app-text @fadeIn
                    class="description">{{ config.anotherRound.description.active | textTranslate: currentLanguage }}
          </app-text>
        } @else {
          <app-text @fadeIn
                    class="description">{{ config.anotherRound.description.normal | textTranslate: currentLanguage }}
          </app-text>
        }
      }
    </div>
  </button>
}

@if (withCallWaiterRequestBill && config.requestBill.enabled) {
  @let active = callWaiterRequestBill;
  @let disabled = callWaiterMain || callWaiterAnotherRound;
  @let labelFallback = config.requestBill.label.normal | textTranslate:'fallback';

  <button
    class="button"
    [class.active]="active"
    [disabled]="disabled"
    [coreUserActivityClickTracking]="callWaiterService.getTrackingName('secondary', active)"
    (click)="onClickCallWaiterRequestBill($event)"
  >
    @if (config.requestBill.icon) {
      @let icon = (
        active && config.requestBill.icon.active
          ? config.requestBill.icon.active
          : config.requestBill.icon.normal
      ) | imageTranslate: currentLanguage;

      <app-image
        class="icon"
        [image]="icon"
        [alt]="labelFallback"
      />
    }

    <div class="content">
      @if (active && config.requestBill.label.active) {
        <app-text @fadeIn class="label">{{ config.requestBill.label.active | textTranslate: currentLanguage }}
        </app-text>
      } @else {
        <app-text @fadeIn class="label">{{ config.requestBill.label.normal | textTranslate: currentLanguage }}
        </app-text>
      }

      @if (config.requestBill.description) {
        @if (active && config.requestBill.description.active) {
          <app-text @fadeIn
                    class="description">{{ config.requestBill.description.active | textTranslate: currentLanguage }}
          </app-text>
        } @else {
          <app-text @fadeIn
                    class="description">{{ config.requestBill.description.normal | textTranslate: currentLanguage }}
          </app-text>
        }
      }
    </div>
  </button>
}
